import MarkdownIt from 'markdown-it'
import MarkdownItCollapsible from 'markdown-it-collapsible'

export function createMarkdownRenderer(opts?: {
  enable?: string[]
  disable?: string[]
}) {
  return new MarkdownIt({ html: true })
    .enable(opts?.enable ?? [], true)
    .disable(opts?.disable ?? [], true)
    .use(MarkdownItCollapsible)
    .use(OpenLinkInNewWindow)
    .use(Underline)
    .use(LimitHtmlTags)
}

export const mdFull = createMarkdownRenderer()
export const mdUser = createMarkdownRenderer({
  disable: ['image', 'link'],
})

// Make links open in new windows
function OpenLinkInNewWindow(md: MarkdownIt) {
  md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    tokens[idx].attrSet('target', '_blank')
    return self.renderToken(tokens, idx, options)
  }
}

// Limit HTML tags rendering
// Allowlist:
//   - <br>
function LimitHtmlTags(md: MarkdownIt) {
  md.renderer.rules.html_block = md.renderer.rules.html_inline = function (
    tokens,
    idx,
  ) {
    const content = tokens[idx].content
    if (/^<br\s*\/?>$/.test(content)) {
      return content
    } else {
      return md.utils.escapeHtml(content)
    }
  }
}

function Underline(md: MarkdownIt) {
  md.renderer.rules.em_open = md.renderer.rules.em_close = function renderEm(
    tokens,
    idx,
    options,
    env,
    self,
  ) {
    const token = tokens[idx]
    if (token.markup === '_') {
      token.tag = 'u'
    }
    return self.renderToken(tokens, idx, options)
  }
}
